module.exports = __webpack_public_path__ + "static/media/303KnobLabel--decay.2e0c7b79.svg";